module.exports = __webpack_public_path__ + "media/images/chat-1e68f296542cad05827ae3e48a37d113.svg";